document.addEventListener('DOMContentLoaded', function () {
  const inputs = document.querySelectorAll('#otp-inputs-container .otp-input');

  inputs.forEach((input, index) => {
    input.addEventListener('input', (e) => {
      const rawVal = e.target.value;

      if (!/^\d$/.test(rawVal)) {
        e.target.value = '';
        input.dataset.value = '';
        return;
      }

      input.dataset.value = rawVal;
      input.value = 'X';

      if (index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        if (input.dataset.value === '') {
          if (index > 0) {
            inputs[index - 1].focus();
          }
        } else {
          input.value = '';
          input.dataset.value = '';
        }
        e.preventDefault();
      }
    });

    input.addEventListener('paste', (e) => {
      const pasteData = e.clipboardData.getData('text').trim();
      if (/^\d+$/.test(pasteData)) {
        for (let i = 0; i < inputs.length && i < pasteData.length; i++) {
          inputs[i].value = 'X';
          inputs[i].dataset.value = pasteData[i];
        }
        const nextIndex = Math.min(pasteData.length, inputs.length - 1);
        inputs[nextIndex].focus();
        e.preventDefault();
      }
    });
  });

  window.getOtpValue = function () {
    return Array.from(inputs)
      .map((input) => input.dataset.value)
      .join('');
  };

  window.getOtpInputsLength = function () {
    return Array.from(inputs).length;
  };

  window.clearOtpInputs = function () {
    inputs.forEach((input) => {
      input.value = '';
      input.dataset.value = '';
    });
    if (inputs.length > 0) {
      inputs[0].focus();
    }
  };
});
